import React, { useMemo } from 'react';
import KanbanCard from './KanbanCard';

const STATUS_COLUMNS = [
  { key: 'incoming', title: 'Incoming' },
  { key: 'in-progress', title: 'In Progress' },
  { key: 'resolved', title: 'Resolved' },
  { key: 'rejected', title: 'Rejected' }
];

const TaskKanbanBoard = ({ tasks = [], loading = false, totalCount = 0, renderTaskItem, renderKanbanItem, onTaskClick }) => {
  const grouped = useMemo(() => {
    const map = new Map();
    STATUS_COLUMNS.forEach(col => map.set(col.key, []));
    for (const t of tasks) {
      const status = (t.status || '').toLowerCase();
      if (map.has(status)) {
        map.get(status).push(t);
      } else {
        if (!map.has('incoming')) map.set('incoming', []);
        map.get('incoming').push(t);
      }
    }
    return map;
  }, [tasks]);

  if (loading && tasks.length === 0) {
    return <div className="loading-state">Loading tasks...</div>;
  }

  return (
    <div className="kanban-board" role="list" aria-label="Kanban board">
      {STATUS_COLUMNS.map(col => (
        <div key={col.key} className="kanban-column" role="listitem" aria-label={`${col.title} column`}>
          <div className="kanban-column-header">
            <span>{col.title}</span>
            <span className="kanban-count" aria-label={`${grouped.get(col.key)?.length || 0} tasks`}>
              {grouped.get(col.key)?.length || 0}
            </span>
          </div>
          <div className="kanban-column-body">
            {(grouped.get(col.key) || []).length === 0 && (
              <div className="kanban-empty" aria-label="No tasks">No tasks</div>
            )}
            {(grouped.get(col.key) || []).map(task => (
              <div key={task.id} className="kanban-card" onClick={() => onTaskClick && onTaskClick(task)}>
                {renderKanbanItem 
                  ? renderKanbanItem(task)
                  : <KanbanCard task={task} onClick={() => onTaskClick && onTaskClick(task)} />}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TaskKanbanBoard;


